<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row align-items-center mb-1">
        <div class="col-md-6">
          <div class="h2">{{routeName}}</div>
        </div>
        <div class="col-md-2 offset-md-4 text-right center">
          <router-link to="/admin/corporations" class="btn btn-primary" role="button">
            back
          </router-link>
        </div>
      </div>
      <form @submit.prevent="update" v-if="corporation">
        <div class="row justify-content-md-center">
          <div class="col-12">
            <div class="row">
              <div class="col-md-3">
                <fg-input type="text"
                          v-model="corporation.name"
                          label="Name"
                          placeholder="Enter name"
                          v-validate="rules.name"
                          data-vv-name="name"
                          cus-name="name"
                          :has-errors="errors"
                          :is-fields="fields">
                </fg-input>
              </div>
              <div class="col-md-3">
                <fg-input type="text"
                          v-model="corporation.accountLimit"
                          label="Account Limit"
                          placeholder="Enter Account Limit"
                          v-validate="rules.accountLimit"
                          data-vv-name="account limit"
                          cus-name="account limit"
                          :has-errors="errors"
                          :is-fields="fields">
                </fg-input>
              </div>
              <div class="col-md-3">
                <fg-input type="text"
                          v-model="corporation.domain"
                          label="Domain"
                          placeholder="Enter Domain"
                          v-validate="rules.domain"
                          data-vv-name="domain"
                          cus-name="domain"
                          :has-errors="errors"
                          :is-fields="fields">
                </fg-input>
              </div>
              <div class="col-md-3">
                <fg-input type="text"
                          v-model="corporation.invitation_code"
                          label="Type"
                          placeholder="Enter Type"
                          v-validate="rules.invitation_code"
                          data-vv-name="invitation_code"
                          cus-name="invitation_code"
                          :has-errors="errors"
                          :is-fields="fields">
                </fg-input>
              </div>
              <div class="col-md-3" v-if="status.length">
                <fg-select
                  v-model="corporation.active"
                  label="Status"
                  v-validate="rules.active"
                  data-vv-name="active"
                  cus-name="active"
                  :has-errors="errors"
                  :is-fields="fields"
                  :list="status"
                  selectedKey="id"
                >
                </fg-select>
              </div>

              <div class="col-md-3">
                <fg-input type="text"
                          v-model="corporation.contactFirstName"
                          label="Contact First Name"
                          placeholder="Enter Contact First Name"
                          v-validate="rules.contactFirstName"
                          data-vv-name="contact first name"
                          cus-name="contact first name"
                          :has-errors="errors"
                          :is-fields="fields">
                </fg-input>
              </div>
              <div class="col-md-3">
                <fg-input type="text"
                          v-model="corporation.contactLastName"
                          label="Contact Last Name"
                          placeholder="Enter Contact Last Name"
                          v-validate="rules.contactLastName"
                          data-vv-name="contact last name"
                          cus-name="contact last name"
                          :has-errors="errors"
                          :is-fields="fields">
                </fg-input>
              </div>
              <div class="col-md-3">
                <fg-input type="text"
                          v-model="corporation.contactEmail"
                          label="Contact Email"
                          placeholder="Enter Contact Email"
                          v-validate="rules.contactEmail"
                          data-vv-name="contact email"
                          cus-name="contact email"
                          :has-errors="errors"
                          :is-fields="fields">
                </fg-input>
              </div>
              <div class="col-md-3">
                <fg-input type="text"
                          v-model="corporation.contactPhone"
                          label="Contact Phone"
                          placeholder="Enter Contact Phone"
                          v-validate="rules.contactPhone"
                          data-vv-name="contact phone"
                          cus-name="contact phone"
                          :has-errors="errors"
                          :is-fields="fields">
                </fg-input>
              </div>

              <div class="col-md-3">
                <fg-input type="text"
                          v-model="corporation.contactAddress"
                          label="Contact Address"
                          placeholder="Enter Contact Address"
                          v-validate="rules.contactAddress"
                          data-vv-name="contact address"
                          cus-name="contact address"
                          :has-errors="errors"
                          :is-fields="fields">
                </fg-input>
              </div>
              <div class="col-md-3">
                <fg-input type="text"
                          v-model="corporation.contactCity"
                          label="Contact City"
                          placeholder="Enter Contact City"
                          v-validate="rules.contactCity"
                          data-vv-name="contact city"
                          cus-name="contact city"
                          :has-errors="errors"
                          :is-fields="fields">
                </fg-input>
              </div>
              <div class="col-md-3">
                <fg-input type="text"
                          v-model="corporation.contactState"
                          label="Contact State"
                          placeholder="Enter Contact State"
                          v-validate="rules.contactState"
                          data-vv-name="contact state"
                          cus-name="contact state"
                          :has-errors="errors"
                          :is-fields="fields">
                </fg-input>
              </div>
              <div class="col-md-3">
                <fg-input type="text"
                          v-model="corporation.contactZip"
                          label="Contact Zip"
                          placeholder="Enter Contact Zip"
                          v-validate="rules.contactZip"
                          data-vv-name="contact zip"
                          cus-name="contact zip"
                          :has-errors="errors"
                          :is-fields="fields">
                </fg-input>
              </div>
              <div class="col-12">
                <fg-text-area
                  rows="2"
                  v-model="corporation.description"
                  label="Description"
                  placeholder="Enter Description"
                  v-validate="rules.description"
                  data-vv-name="description"
                  cus-name="description"
                  :has-errors="errors"
                  :is-fields="fields"
                >
                </fg-text-area>
              </div>

<!--              <div class="col-12">-->
<!--                <fg-text-area-->
<!--                  rows="2"-->
<!--                  v-model="corporation.welcomeMessage"-->
<!--                  label="Welcome Message"-->
<!--                  placeholder="Enter welcome message"-->
<!--                  v-validate="rules.welcomeMessage"-->
<!--                  data-vv-name="welcome message"-->
<!--                  cus-name="welcome message"-->
<!--                  :has-errors="errors"-->
<!--                  :is-fields="fields"-->
<!--                >-->
<!--                </fg-text-area>-->
<!--              </div>-->

<!--              <div class="col-12">-->
<!--                <fg-text-area-->
<!--                  rows="2"-->
<!--                  v-model="corporation.button_label_01"-->
<!--                  label="Button Label"-->
<!--                  placeholder="Enter Button Label"-->
<!--                  v-validate="rules.button_label_01"-->
<!--                  data-vv-name="Button Label"-->
<!--                  cus-name="Button Label"-->
<!--                  :has-errors="errors"-->
<!--                  :is-fields="fields"-->
<!--                >-->
<!--                </fg-text-area>-->
<!--              </div>-->
<!--              <div class="col-12">-->
<!--                <fg-text-area-->
<!--                  rows="2"-->
<!--                  v-model="corporation.signupGiftDesc"-->
<!--                  label="Gift Redeem Package Description"-->
<!--                  placeholder="Enter Package Description"-->
<!--                >-->
<!--                </fg-text-area>-->
<!--              </div>-->

              <div class="col-md-6 col-xs-12">
                <fg-image type="file"
                          v-on:file="updateLargeImg"
                          v-model="corporation.largeImage"
                          label="Large Image"
                          v-validate="rules.largeImage"
                          data-vv-name="large image"
                          cus-name="large image"
                          :has-errors="errors"
                          :is-fields="fields">
                </fg-image>
              </div>
              <div class="col-md-6 col-xs-12">
                <fg-image type="file"
                          v-on:file="updateSmallImg"
                          v-model="corporation.smallImage"
                          label="Small Image"
                          v-validate="rules.smallImage"
                          data-vv-name="small image"
                          cus-name="small image"
                          :has-errors="errors"
                          :is-fields="fields">
                </fg-image>
              </div>
              <div class="col-md-12" v-if="memebershipEmailsFlag.length">
                <fg-select
                  v-model="corporation.filterEmails "
                  label="Stop sending Freemium, Teaser and Takeaway emails"
                  :is-fields="fields"
                  :list="memebershipEmailsFlag"
                  selectedKey="id"
                >
                </fg-select>
              </div>
              <br/>
              <legend>Community Page Setting</legend><hr>
              <br/>
              <div class="col-md-2" v-if="corpStatus.length">
                <fg-select
                  v-model="corporation.enableCorporatePage"
                  label="Page Status"
                  :is-fields="fields"
                  :list="corpStatus"
                  selectedKey="id"
                >
                </fg-select>
              </div>
              <div class="col-md-2" v-if="spotlightSection.length">
                <fg-select
                  v-model="corporation.showSpotlightSection"
                  label="Spotlight Status"
                  :is-fields="fields"
                  :list="spotlightSection"
                  selectedKey="id"
                >
                </fg-select>
              </div>
              <div class="col-md-2" v-if="pinnedSection.length">
                <fg-select
                  v-model="corporation.showPinnedMessages"
                  label="Pinned Msgs Status"
                  :is-fields="fields"
                  :list="pinnedSection"
                  selectedKey="id"
                >
                </fg-select>
              </div>
              <div class="col-md-3" v-if="defaultCorpTabStatus.length">
                <fg-select
                  v-model="corporation.defaultCorpTab"
                  label="Default Tab"
                  :is-fields="fields"
                  :list="defaultCorpTabStatus"
                  selectedKey="id"
                >
                </fg-select>
              </div>
              <div class="col-md-3" v-if="groupList.length">
                <fg-select
                  v-model="corporation.corpGroupDefinitionId"
                  label="Group"
                  :is-fields="fields"
                  :list="groupList"
                  selectedKey="id"
                >
                </fg-select>
              </div>
              <div class="col-md-12" v-if="userList">
                <label>Select Super Users</label>
                <multiselect
                  v-model="corporation.csvCorpSuperUserIds"
                  placeholder="Select Super Users"
                  :multiple="true"
                  :taggable="true"
                  :options="userList.map(type => type.id)"
                  :custom-label="opt => userList.find(x => x.id == opt).name">
                  >
                </multiselect>
              </div>
              <div class="col-md-12">
                <fg-input type="text"
                          v-model="corporation.spotlightPic"
                          label="Spotlight Image URL"
                          placeholder="Enter Spotlight Image"
                >
                </fg-input>
              </div>
              <div class="col-md-12">
                <fg-text-area type="text"
                              v-model="corporation.pageWelcomeMessage"
                              label="Corporate Page Welcome Message"
                              placeholder="Enter Message"
                              data-vv-name="pageWelcomeMessage"
                              cus-name="pageWelcomeMessage"
                >
                </fg-text-area>
              </div>
              <div class="col-md-12">
                <fg-text-area type="text"
                              v-model="corporation.spotlightQuote"
                              label="Enter Spotlight Quote"
                              placeholder="Enter Spotlight Quote"
                              data-vv-name="Quote"
                              cus-name="Quote"
                >
                </fg-text-area>
              </div>
              <div class="col-md-12">
                <fg-text-area type="text"
                              v-model="corporation.spotlightPara1"
                              label="Enter Spotlight Paragraph 1"
                              placeholder="Enter Spotlight Paragraph 1"
                              data-vv-name="paragraph4"
                              cus-name="paragraph4"
                >
                </fg-text-area>
              </div>
              <div class="col-md-12">
                <fg-text-area type="text"
                              v-model="corporation.spotlightPara2"
                              label="Enter Spotlight Paragraph 2"
                              placeholder="Enter Spotlight Paragraph 2"
                              data-vv-name="paragraph4"
                              cus-name="paragraph4"
                >
                </fg-text-area>
              </div>
              <div class="col-md-12">
                <fg-text-area type="text"
                              v-model="corporation.spotlightPara3"
                              label="Enter Spotlight Paragraph 3"
                              placeholder="Enter Spotlight Paragraph 3"
                              data-vv-name="paragraph4"
                              cus-name="paragraph4"
                >
                </fg-text-area>
              </div>
              <div class="col-md-12">
                <fg-text-area type="text"
                              v-model="corporation.privateEventHeading"
                              label="Private Events Heading"
                              placeholder="Heading"
                              data-vv-name="privateEventHeading"
                              cus-name="privateEventHeading"
                >
                </fg-text-area>
              </div>
              <div class="col-md-12">
                <fg-text-area type="text"
                              v-model="corporation.toneEventHeading"
                              label="TONE Events Heading"
                              placeholder="Heading"
                              data-vv-name="toneEventHeading"
                              cus-name="toneEventHeading"
                >
                </fg-text-area>
              </div>
              <div class="col-md-12">
                <fg-text-area type="text"
                              v-model="corporation.archiveEventHeading"
                              label="Archive Section Heading"
                              placeholder="Enter Heading"
                              data-vv-name="archiveEventHeading"
                              cus-name="archiveEventHeading"
                >
                </fg-text-area>
              </div>
              <div class="col-md-12">
                <fg-text-area type="text"
                              v-model="corporation.pinnedMessageHeading"
                              label="Pinned Message Heading"
                              placeholder="Enter Heading"
                              data-vv-name="pinnedMessageHeading"
                              cus-name="pinnedMessageHeading"
                >
                </fg-text-area>
              </div>
              <div class="col-md-12">
                <fg-text-area type="text"
                              v-model="corporation.playlistHeading"
                              label="Playlist Section Heading"
                              placeholder="Enter Heading"
                              data-vv-name="playlistHeading"
                              cus-name="playlistHeading"
                >
                </fg-text-area>
              </div>
              <br/>
              <legend>Profile/Signup Page Settings</legend><hr><br>
              <div class="col-md-4" v-if="mobileFlags.length">
                <fg-select
                  v-model="corporation.phoneFlag"
                  label="Mobile Field Visibility"
                  :is-fields="fields"
                  :list="mobileFlags"
                  selectedKey="id"
                >
                </fg-select>
              </div>
              <div class="col-md-4" v-if="dobFlags.length">
                <fg-select
                  v-model="corporation.dobFlag"
                  label="DOB Field Visibility"
                  :is-fields="fields"
                  :list="dobFlags"
                  selectedKey="id"
                >
                </fg-select>
              </div>
              <div class="col-md-4" v-if="shoeMotifFlags.length">
                <fg-select
                  v-model="corporation.showShoeMotif"
                  label="Shoe-motif Flag"
                  :is-fields="fields"
                  :list="shoeMotifFlags"
                  selectedKey="id"
                >
                </fg-select>
              </div>
              <br/>
              <legend>Corporation Private Video Settings</legend><hr><br>
              <div class="col-md-12">
                <fg-input type="text"
                          v-model="corporation.videoTabHeading"
                          label="Private Video Section Heading"
                          placeholder="Enter Message"
                          :is-fields="fields">
                </fg-input>
              </div>
              <div class="col-md-12">
                <fg-input type="text"
                          v-model="corporation.csvShowVideoCodes"
                          label="Video Codes (To show)"
                          placeholder="Enter Video Codes (comma separated)"
                          :is-fields="fields">
                </fg-input>
              </div>
              <div class="col-md-12">
                <fg-input type="text"
                          v-model="corporation.csvHiddenVideoCodes"
                          label="Video Codes (To hide)"
                          placeholder="Enter Video Codes (comma separated)"
                          :is-fields="fields">
                </fg-input>
              </div>
              <div class="col-md-12">
                <fg-input type="text"
                          v-model="corporation.profileCsvVideos"
                          label="Suggested Videos for New Users"
                          placeholder="Enter Video Codes (comma separated)"
                          :is-fields="fields">
                </fg-input>
              </div>
              <br/>
              <legend>Custom Banner Status</legend><br>
              <div class="col-md-12" v-if="giftIconStatus.length">
                <fg-select
                  v-model="corporation.giftIconState"
                  label="Gifting Status"
                  :is-fields="fields"
                  :list="giftIconStatus"
                  selectedKey="id"
                >
                </fg-select>
              </div>
              <div class="col-md-8" v-if="showCustomMessageFlag">
                <fg-input type="text"
                          v-model="corporation.giftIconMessage"
                          label="Custom Message"
                          placeholder="Enter Custom Message"
                          :is-fields="fields">
                </fg-input>
              </div>
              <div class="col-md-4" v-if="showCustomMessageFlag">
                <fg-input type="text"
                          v-model="corporation.giftIconUrl"
                          label="Enter URL (Optional)"
                          placeholder="Enter Url"
                          :is-fields="fields">
                </fg-input>
              </div>
              <legend>Event Banner Status</legend><br>
              <div class="col-md-12" v-if="eventBannerStatus.length">
                <fg-select
                  v-model="corporation.bnrLinkState"
                  label="Event Banner Behavior"
                  :is-fields="fields"
                  :list="eventBannerStatus"
                  selectedKey="id"
                >
                </fg-select>
              </div>
              <div class="col-md-6" v-if="showCustomBannerFlag">
                <label>Start Date</label>
                <datetime v-model="startDate"
                          input-class="form-control"
                          placeholder="Choose a Date"
                          type="datetime"
                          :min-datetime="startDate"
                          input-format="DD-MM-YYYY HH:mm"
                          auto-continue required>

                </datetime>
              </div>
              <div class="col-md-6" v-if="showCustomBannerFlag">
                <label>End Date</label>
                <datetime v-model="endDate"
                          input-class="form-control"
                          placeholder="Choose a Date"
                          type="datetime"
                          input-format="DD-MM-YYYY HH:mm"
                          :min-datetime="startDate"
                          auto-continue required>

                </datetime>
              </div>
              <div class="col-md-8" v-if="corporation.bnrLinkState.toString() === '3'">
                <fg-input type="text"
                          v-model="corporation.bnrCustomMsg"
                          label="Custom Banner"
                          placeholder="Enter Custom Banner"
                          :is-fields="fields" required>
                </fg-input>
              </div>
              <div class="col-md-4" v-if="corporation.bnrLinkState.toString() === '3'">
                <fg-input type="text"
                          v-model="corporation.bnrCustomMsgUrl"
                          label="Enter URL"
                          placeholder="Enter Url"
                          :is-fields="fields" required>
                </fg-input>
              </div>
              <br/>
              <legend>Manage Email Flow</legend><hr>
              <br/>
              <div class="col-md-4">
                <div class="checkbox">
                  <label >
                    <input type="checkbox" class="form-input" v-model="allowEmail" :disabled="corporation.cceSendEmail === 2 && allowEmail"> Send Email (On Enabling Page)
                  </label>
                </div>
              </div>
              <div class="col-md-4">
                <div class="checkbox">
                  <label >
                    <input type="checkbox" class="form-input" v-model="allowCoachingSection"> Allow Coaching Section
                  </label>
                </div>
              </div>
              <div class="col-md-4">
                <div class="checkbox">
                  <label >
                    <input type="checkbox" class="form-input" v-model="allowLiveSection">  Allow Live Event Section
                  </label>
                </div>
              </div>
              <div class="col-md-4">
                <div class="checkbox">
                  <label >
                    <input type="checkbox" class="form-input" v-model="allowCustonSection"> Allow Custom Content Section
                  </label>
                </div>
              </div>
              <div class="col-md-4">
                <div class="checkbox">
                  <label >
                    <input type="checkbox" class="form-input" v-model="allowVideoShareSection"> Allow Share Video Section
                  </label>
                </div>
              </div>
              <div  class="col-md-12 text-center alert alert-danger" role="alert" v-if="allowEmail && corporation.cceSendEmail !== 2">
                'Send Email' option will send one time email to all users in the corporation!
              </div>
              <div class="col-md-12 text-center alert alert-dark" role="alert" v-if="corporation.cceSendEmail === 2">
                One Time Email has already been sent for all corporation users!
              </div>
              <br/>
<!--              <legend>Manage Package Expiry (It will override gift package rules)</legend><hr>-->
<!--              <br/>-->
<!--              <div class="col-md-3">-->
<!--                <div class="checkbox">-->
<!--                  <label >-->
<!--                    <input type="checkbox" class="form-input" v-model="allowPackageOverride"> Override Package Settings-->
<!--                  </label>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="col-md-4" v-if="allowPackageOverride">-->
<!--                <label>New Trial Expiry Date</label>-->
<!--                <datetime v-model="trialExpiryDate"-->
<!--                          input-class="form-control"-->
<!--                          placeholder="Choose a Date"-->
<!--                          type="date"-->
<!--                          input-format="DD-MM-YYYY"-->
<!--                          :min-datetime="startDate"-->
<!--                          auto-continue required>-->

<!--                </datetime>-->
<!--              </div>-->
              <br/>
              <legend>Video/Playlist Sharing Settings</legend><hr>
              <br/>
              <div class="col-md-12" v-if="corpVideoShareOptions.length">
                <fg-select
                  v-model="corporation.corpSharingPermissions.shareVideoPermission"
                  label="Video Share Options"
                  :is-fields="fields"
                  :list="corpVideoShareOptions"
                  selectedKey="id"
                >
                </fg-select>
              </div>
              <div class="col-md-12" v-if="showRegularVideoShareUsers && (corporation.corpSharingPermissions.shareVideoPermission > 1)">
                <!--                            <button >Select All</button>-->
                <!--                            <button @click="toggleSelection('shareVideoPermission', false)" type="button">De-Select All</button>-->
                <button class="btn btn-primary" @click="toggleSelection('shareVideoPermission', true)" type="button"><i class="fa fa-bars"></i> Select All</button>
                <button class="btn btn-warning" @click="toggleSelection('shareVideoPermission', false)" type="button"><i class="fa fa-close"></i> De-Select All</button>
                <multiselect
                  v-model="corporation.corpSharingPermissions.shrVidPermUserIdCsv"
                  placeholder="Select Users for Video Sharing (Corp)"
                  :multiple="true"
                  :taggable="true"
                  :options="userList.map(type => type.id)"
                  :custom-label="opt => userList.find(x => x.id == opt).name">
                  >
                </multiselect>
              </div>

              <div class="col-md-12" v-if="corpVideoShareOptions.length">
                <fg-select
                  v-model="corporation.corpSharingPermissions.corpPlaylistShareOptnPermission"
                  label="Corporate Playlist Share Options (Playlist Page)"
                  :is-fields="fields"
                  :list="corpVideoShareOptions"
                  selectedKey="id"
                >
                </fg-select>
              </div>
              <div class="col-md-12" v-if="showVideoShareUsers && (corporation.corpSharingPermissions.corpPlaylistShareOptnPermission > 1)">
                <button class="btn btn-primary" @click="toggleSelection('corpPlaylistShareOptnPermission', true)" type="button"><i class="fa fa-bars"></i> Select All</button>
                <button class="btn btn-warning" @click="toggleSelection('corpPlaylistShareOptnPermission', false)" type="button"><i class="fa fa-close"></i> De-Select All</button>
                <multiselect
                  v-model="corporation.corpSharingPermissions.corpPlaylistShrareOptnCsv"
                  placeholder="Select Users for Corp Playlist Sharing (Playlist Page)"
                  :multiple="true"
                  :taggable="true"
                  :options="userList.map(type => type.id)"
                  :custom-label="opt => userList.find(x => x.id == opt).name">
                  >
                </multiselect>
              </div>

              <div class="col-md-12" v-if="corpVideoShareOptions.length">
                <fg-select
                  v-model="corporation.corpSharingPermissions.shareCompanyPlaylistPermission"
                  label="Corporate Playlist Share Options (corporate community page)"
                  :is-fields="fields"
                  :list="corpVideoShareOptions"
                  selectedKey="id"
                >
                </fg-select>
              </div>
              <div class="col-md-12" v-if="showCompPlusers && (corporation.corpSharingPermissions.shareCompanyPlaylistPermission > 1)">
                <button class="btn btn-primary" @click="toggleSelection('shareCompanyPlaylistPermission', true)" type="button"><i class="fa fa-bars"></i> Select All</button>
                <button class="btn btn-warning" @click="toggleSelection('shareCompanyPlaylistPermission', false)" type="button"><i class="fa fa-close"></i> De-Select All</button>
                <multiselect
                  v-model="corporation.corpSharingPermissions.shrCompPlistPermUserIdCsv"
                  placeholder="Select Users for Corporate Playlist Sharing"
                  :multiple="true"
                  :taggable="true"
                  :options="userList.map(type => type.id)"
                  :custom-label="opt => userList.find(x => x.id == opt).name">
                  >
                </multiselect>
              </div>

              <div class="col-md-12" v-if="corpVideoShareOptions.length">
                <fg-select
                  v-model="corporation.corpSharingPermissions.sharePersonalPlaylistPermission"
                  label="Personal Playlist Share Options"
                  :is-fields="fields"
                  :list="corpVideoShareOptions"
                  selectedKey="id"
                >
                </fg-select>
              </div>
              <div class="col-md-12" v-if="showPersonalShareUsers && (corporation.corpSharingPermissions.sharePersonalPlaylistPermission > 1)">
                <button class="btn btn-primary" @click="toggleSelection('sharePersonalPlaylistPermission', true)" type="button"><i class="fa fa-bars"></i> Select All</button>
                <button class="btn btn-warning" @click="toggleSelection('sharePersonalPlaylistPermission', false)" type="button"><i class="fa fa-close"></i> De-Select All</button>
                <multiselect
                  v-model="corporation.corpSharingPermissions.shrPerPlistPermUserIdCsv"
                  placeholder="Select Users for Personal Playlist Sharing"
                  :multiple="true"
                  :taggable="true"
                  :options="userList.map(type => type.id)"
                  :custom-label="opt => userList.find(x => x.id == opt).name">
                  >
                </multiselect>
              </div>

              <div class="col-md-12" v-if="corpVideoShareOptions.length">
                <fg-select
                  v-model="corporation.corpSharingPermissions.shareTrendingPlaylistPermission"
                  label="Trending Playlist Share Options"
                  :is-fields="fields"
                  :list="corpVideoShareOptions"
                  selectedKey="id"
                >
                </fg-select>
              </div>
              <div class="col-md-12" v-if="showTrendingShareUsers && (corporation.corpSharingPermissions.shareTrendingPlaylistPermission > 1)">
                <button class="btn btn-primary" @click="toggleSelection('shareTrendingPlaylistPermission', true)" type="button"><i class="fa fa-bars"></i> Select All</button>
                <button class="btn btn-warning" @click="toggleSelection('shareTrendingPlaylistPermission', false)" type="button"><i class="fa fa-close"></i> De-Select All</button>
                <multiselect
                  v-model="corporation.corpSharingPermissions.shrTrndPlistPermUserIdCsv"
                  placeholder="Select Users for Trending Playlist Sharing"
                  :multiple="true"
                  :taggable="true"
                  :options="userList.map(type => type.id)"
                  :custom-label="opt => userList.find(x => x.id == opt).name">
                  >
                </multiselect>
              </div>

              <div class="col-md-12" v-if="corpVideoShareOptions.length">
                <fg-select
                  v-model="corporation.corpSharingPermissions.shareEventCoachingTipPermission"
                  label="Archive Playlist Share Options (Events Page)"
                  :is-fields="fields"
                  :list="corpVideoShareOptions"
                  selectedKey="id"
                >
                </fg-select>
              </div>
              <div class="col-md-12" v-if="showEventArchiveUsers && (corporation.corpSharingPermissions.shareEventCoachingTipPermission > 1)">
                <button class="btn btn-primary" @click="toggleSelection('shareEventCoachingTipPermission', true)" type="button"><i class="fa fa-bars"></i> Select All</button>
                <button class="btn btn-warning" @click="toggleSelection('shareEventCoachingTipPermission', false)" type="button"><i class="fa fa-close"></i> De-Select All</button>
                <multiselect
                  v-model="corporation.corpSharingPermissions.shrEventCoachPlistPermUserIdCsv"
                  placeholder="Select Users for Archive Playlist Sharing (Events Page)"
                  :multiple="true"
                  :taggable="true"
                  :options="userList.map(type => type.id)"
                  :custom-label="opt => userList.find(x => x.id == opt).name">
                  >
                </multiselect>
              </div>

              <div class="col-md-12" v-if="corpVideoShareOptions.length">
                <fg-select
                  v-model="corporation.corpSharingPermissions.shareExpertCoachingTipPermission"
                  label="Archive Playlist Share Options (Expert Page)"
                  :is-fields="fields"
                  :list="corpVideoShareOptions"
                  selectedKey="id"
                >
                </fg-select>
              </div>
              <div class="col-md-12" v-if="showExpertArchiveUsers && (corporation.corpSharingPermissions.shareExpertCoachingTipPermission > 1)">
                <button class="btn btn-primary" @click="toggleSelection('shareExpertCoachingTipPermission', true)" type="button"><i class="fa fa-bars"></i> Select All</button>
                <button class="btn btn-warning" @click="toggleSelection('shareExpertCoachingTipPermission', false)" type="button"><i class="fa fa-close"></i> De-Select All</button>
                <multiselect
                  v-model="corporation.corpSharingPermissions.shrExpertCoachPlistPermUserIdCsv"
                  placeholder="Select Users for Archive Playlist Sharing (Expert Page)"
                  :multiple="true"
                  :taggable="true"
                  :options="userList.map(type => type.id)"
                  :custom-label="opt => userList.find(x => x.id == opt).name">
                  >
                </multiselect>
              </div>

              <div class="col-md-12" v-if="corpVideoShareOptions.length">
                <fg-select
                  v-model="corporation.corpSharingPermissions.shareArchivePlistPermission"
                  label="Archive Playlist Share Options (Player Page)"
                  :is-fields="fields"
                  :list="corpVideoShareOptions"
                  selectedKey="id"
                >
                </fg-select>
              </div>
              <div class="col-md-12" v-if="showArchiveShareUsers && (corporation.corpSharingPermissions.shareArchivePlistPermission > 1)">
                <button class="btn btn-primary" @click="toggleSelection('shareArchivePlistPermission', true)" type="button"><i class="fa fa-bars"></i> Select All</button>
                <button class="btn btn-warning" @click="toggleSelection('shareArchivePlistPermission', false)" type="button"><i class="fa fa-close"></i> De-Select All</button>
                <multiselect
                  v-model="corporation.corpSharingPermissions.shrArchivePlistPermUserIdCsv"
                  placeholder="Select Users for Archive Playlist Sharing (Player Page)"
                  :multiple="true"
                  :taggable="true"
                  :options="userList.map(type => type.id)"
                  :custom-label="opt => userList.find(x => x.id == opt).name">
                  >
                </multiselect>
              </div>
            </div>

            <br/>
            <legend>Event Sharing Settings</legend><hr>
            <br/>
            <div class="col-md-12" v-if="corpEventShareOptions.length">
              <fg-select
                v-model="corporation.corpSharingPermissions.corpEventShareOptnPermission"
                label="Event Share Options"
                :is-fields="fields"
                :list="corpEventShareOptions"
                selectedKey="id"
              >
              </fg-select>
            </div>
            <div class="col-md-12" v-if="showEventShareUsers && (corporation.corpSharingPermissions.corpEventShareOptnPermission > 1)">
              <!--                            <button >Select All</button>-->
              <!--                            <button @click="toggleSelection('shareVideoPermission', false)" type="button">De-Select All</button>-->
              <button class="btn btn-primary" @click="toggleSelection('shareEventPermission', true)" type="button"><i class="fa fa-bars"></i> Select All</button>
              <button class="btn btn-warning" @click="toggleSelection('shareEventPermission', false)" type="button"><i class="fa fa-close"></i> De-Select All</button>
              <multiselect
                v-model="corporation.corpSharingPermissions.corpEventShareOptnCsv"
                placeholder="Select Users for Video Sharing (Corp)"
                :multiple="true"
                :taggable="true"
                :options="userList.map(type => type.id)"
                :custom-label="opt => userList.find(x => x.id == opt).name">
                >
              </multiselect>
            </div>

            <div class="col-md-12" v-if="corpEventShareOptions.length">
              <fg-select
                v-model="corporation.corpSharingPermissions.corpArchiveEventOptnPermission"
                label="Private Archive Event Share Options"
                :is-fields="fields"
                :list="corpEventShareOptions"
                selectedKey="id"
              >
              </fg-select>
            </div>

            <div class="col-md-12" v-if="showPrivateEventShareUsers && (corporation.corpSharingPermissions.corpArchiveEventOptnPermission > 1)">
              <!--                            <button >Select All</button>-->
              <!--                            <button @click="toggleSelection('shareVideoPermission', false)" type="button">De-Select All</button>-->
              <button class="btn btn-primary" @click="toggleSelection('sharePrivateEventPermission', true)" type="button"><i class="fa fa-bars"></i> Select All</button>
              <button class="btn btn-warning" @click="toggleSelection('sharePrivateEventPermission', false)" type="button"><i class="fa fa-close"></i> De-Select All</button>
              <multiselect
                v-model="corporation.corpSharingPermissions.corpArchiveEventOptnCsv"
                placeholder="Select Users for Video Sharing (Corp)"
                :multiple="true"
                :taggable="true"
                :options="userList.map(type => type.id)"
                :custom-label="opt => userList.find(x => x.id == opt).name">
                >
              </multiselect>
            </div>



          </div>
          <div class="col-6 text-center">
            <br/>
            <br/>
            <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
              Update Corporation
            </button>
          </div>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import moment from 'moment'
  export default {
    name: 'EditCorporation',
    created (){
      this.fetchAllGroups();
      this.$store.dispatch('GET_SELECTED_CORPORATION', this.$route.params.id).then(() => {
        if (this.corporations) {
          // this.corporation.csvCorpSuperUserIds = this.corporation.csvCorpSuperUserIds.split(',')
          // this.corporation.cceSendEmail = 2
          this.allowPackageOverride = this.corporation.useTrialEndDateCustom  === 1 ? true : false
          this.allowEmail = this.corporation.cceSendEmail > 0 ? true : false
          this.allowLiveSection = this.corporation.cceLiveEventParaAccess === 1 ? true : false
          this.allowCustonSection = this.corporation.cceCustomContentAccess === 1 ? true : false
          this.allowCoachingSection = this.corporation.cceCommCoachingAccess === 1 ? true : false
          this.allowVideoShareSection = this.corporation.cceShareVideoAccess === 1?  true : false
          if (this.corporation.giftIconState === 3) {
            this.showCustomMessageFlag = true
          }
          if (this.corporation.bnrLinkState > 1) {
            this.showCustomBannerFlag = true
            this.startDate = new Date(this.corporation.bnrPvtStartTime).toISOString();
            this.endDate = new Date(this.corporation.bnrPvtEndTime).toISOString();
          }
          if (this.corporation.useTrialEndDateCustom  === 1) {
            this.trialExpiryDate =  new Date(this.corporation.trialEndDateCustom ).toISOString();
          }
          // let permission = this.corporation.corpSharingPermissions
          // if (permission === null || typeof permission === 'undefined') {
          //   this.corporation.corpSharingPermissions = null
          //    this.corporation.corpSharingPermissions = {
          //     "shareVideoPermission": 1,
          //       "shrVidPermUserIdCsv": null,
          //       "sharePersonalPlaylistPermission": 1,
          //       "shrPerPlistPermUserIdCsv": null,
          //       "shareCompanyPlaylistPermission": 1,
          //       "shrCompPlistPermUserIdCsv": null,
          //       "shareTrendingPlaylistPermission": 1,
          //       "shrTrndPlistPermUserIdCsv": null,
          //       "shareEventCoachingTipPermission": 1,
          //       "shrEventCoachPlistPermUserIdCsv": null,
          //       "shareExpertCoachingTipPermission": 1,
          //       "shrExpertCoachPlistPermUserIdCsv": null,
          //       "shareArchivePlistPermission":1,
          //       "shrArchivePlistPermUserIdCsv":null
          //   }
          //    console.log('after adding object', this.corporation)
          // } else {
          //   console.log('setup existing corporation')
          // Normal Video Sharing Option Settings (Regular)
          if (this.corporation.corpSharingPermissions.corpPlaylistShareOptnPermission === '1' || this.corporation.corpSharingPermissions.corpPlaylistShareOptnPermission === '0') {
            this.corporation.corpSharingPermissions.corpPlaylistShrareOptnCsv = null
            this.showRegularVideoShareUsers = false
          } else {
            this.showRegularVideoShareUsers = true
            if (this.corporation.corpSharingPermissions.corpPlaylistShrareOptnCsv) {
              this.corporation.corpSharingPermissions.corpPlaylistShrareOptnCsv = this.corporation.corpSharingPermissions.corpPlaylistShrareOptnCsv.split(',')
            }
          }

          // Normal Video Sharing Option Settings (Corp)
          if (this.corporation.corpSharingPermissions.shareVideoPermission === '1' || this.corporation.corpSharingPermissions.shareVideoPermission === '0') {
            this.corporation.corpSharingPermissions.shrVidPermUserIdCsv = null
            this.showVideoShareUsers = false
          } else {
            this.showVideoShareUsers = true
            if (this.corporation.corpSharingPermissions.shrVidPermUserIdCsv) {
              console.log('share video perm', this.corporation.corpSharingPermissions.shrVidPermUserIdCsv)
              console.log('share video perm user list', this.userList)
              this.corporation.corpSharingPermissions.shrVidPermUserIdCsv = this.corporation.corpSharingPermissions.shrVidPermUserIdCsv.split(',')
            }
          }
          // Company Playlist Sharing Option Settings
          if (this.corporation.corpSharingPermissions.shareCompanyPlaylistPermission === '1' || this.corporation.corpSharingPermissions.shareCompanyPlaylistPermission === '0') {
            this.corporation.corpSharingPermissions.shrCompPlistPermUserIdCsv = null
            this.showCompPlusers = false
            console.log()
          } else {
            this.showCompPlusers = true
            if (this.corporation.corpSharingPermissions.shrCompPlistPermUserIdCsv) {
              this.corporation.corpSharingPermissions.shrCompPlistPermUserIdCsv = this.corporation.corpSharingPermissions.shrCompPlistPermUserIdCsv.split(',')
            }
          }
          // Personal Video Sharing Option Settings
          if (this.corporation.corpSharingPermissions.sharePersonalPlaylistPermission === '1' || this.corporation.corpSharingPermissions.sharePersonalPlaylistPermission === '0') {
            this.corporation.corpSharingPermissions.shrPerPlistPermUserIdCsv = null
            this.showPersonalShareUsers = false
          } else {
            this.showPersonalShareUsers = true
            if (this.corporation.corpSharingPermissions.shrPerPlistPermUserIdCsv) {
              this.corporation.corpSharingPermissions.shrPerPlistPermUserIdCsv = this.corporation.corpSharingPermissions.shrPerPlistPermUserIdCsv.split(',')
            }
          }
          // Trending Video Sharing Option Settings
          if (this.corporation.corpSharingPermissions.shareTrendingPlaylistPermission === '1' || this.corporation.corpSharingPermissions.shareTrendingPlaylistPermission === '0') {
            this.corporation.corpSharingPermissions.shrTrndPlistPermUserIdCsv = null
            this.showTrendingShareUsers = false
          } else {
            this.showTrendingShareUsers = true
            if (this.corporation.corpSharingPermissions.shrTrndPlistPermUserIdCsv) {
              this.corporation.corpSharingPermissions.shrTrndPlistPermUserIdCsv = this.corporation.corpSharingPermissions.shrTrndPlistPermUserIdCsv.split(',')
            }
          }
          // Archive(Events) Video Sharing Option Settings
          if (this.corporation.corpSharingPermissions.shareEventCoachingTipPermission === '1' || this.corporation.corpSharingPermissions.shareEventCoachingTipPermission === '0') {
            this.corporation.corpSharingPermissions.shrEventCoachPlistPermUserIdCsv = null
            this.showEventArchiveUsers = false
          } else {
            this.showEventArchiveUsers = true
            if (this.corporation.corpSharingPermissions.shrEventCoachPlistPermUserIdCsv) {
              this.corporation.corpSharingPermissions.shrEventCoachPlistPermUserIdCsv = this.corporation.corpSharingPermissions.shrEventCoachPlistPermUserIdCsv.split(',')
            }
          }
          // Event Sharing Option Settings
          if (this.corporation.corpSharingPermissions.corpEventShareOptnPermission === '1' || this.corporation.corpSharingPermissions.corpEventShareOptnPermission === '0') {
            this.corporation.corpSharingPermissions.corpEventShareOptnCsv = null
            this.showEventShareUsers = false
          } else {
            this.showEventShareUsers = true
            if (this.corporation.corpSharingPermissions.corpEventShareOptnCsv) {
              this.corporation.corpSharingPermissions.corpEventShareOptnCsv = this.corporation.corpSharingPermissions.corpEventShareOptnCsv.split(',')
            }
          }
          // Private Event Sharing Option Settings
          if (this.corporation.corpSharingPermissions.corpArchiveEventOptnPermission === '1' || this.corporation.corpSharingPermissions.corpArchiveEventOptnPermission === '0') {
            this.corporation.corpSharingPermissions.corpArchiveEventOptnCsv = null
            this.showPrivateEventShareUsers = false
          } else {
            this.showPrivateEventShareUsers = true
            if (this.corporation.corpSharingPermissions.corpArchiveEventOptnCsv) {
              this.corporation.corpSharingPermissions.corpArchiveEventOptnCsv = this.corporation.corpSharingPermissions.corpArchiveEventOptnCsv.split(',')
            }
          }
          // Archive (experts) Video Sharing Option Settings
          if (this.corporation.corpSharingPermissions.shareExpertCoachingTipPermission === '1' || this.corporation.corpSharingPermissions.shareExpertCoachingTipPermission === '0') {
            this.corporation.corpSharingPermissions.shrExpertCoachPlistPermUserIdCsv = null
            this.showExpertArchiveUsers = false
          } else {
            this.showExpertArchiveUsers = true
            if (this.corporation.corpSharingPermissions.shrExpertCoachPlistPermUserIdCsv) {
              this.corporation.corpSharingPermissions.shrExpertCoachPlistPermUserIdCsv = this.corporation.corpSharingPermissions.shrExpertCoachPlistPermUserIdCsv.split(',')
            }
          }
          // Archive Playlist Video Sharing Option Settings
          if (this.corporation.corpSharingPermissions.shareArchivePlistPermission === '1' || this.corporation.corpSharingPermissions.shareArchivePlistPermission === '0') {
            this.corporation.corpSharingPermissions.shrArchivePlistPermUserIdCsv = null
            this.showArchiveShareUsers = false
          } else {
            this.showArchiveShareUsers = true
            if (this.corporation.corpSharingPermissions.shrArchivePlistPermUserIdCsv) {
              this.corporation.corpSharingPermissions.shrArchivePlistPermUserIdCsv = this.corporation.corpSharingPermissions.shrArchivePlistPermUserIdCsv.split(',')
            }
          }
        }
        if (this.corporation.csvCorpSuperUserIds) {
          this.corporation.csvCorpSuperUserIds = this.corporation.csvCorpSuperUserIds.split(',')
        }
        console.log('updated section', this.corporation)
        // }
      })
      this.fetchAllUsers(this.$route.params.id);
    },
    data () {
      let dateTime = new Date();
      return {
        showRegularVideoShareUsers: false,
        showVideoShareUsers: false,
        showCompPlusers: false,
        showPersonalShareUsers: false,
        showTrendingShareUsers: false,
        showArchiveShareUsers: false,
        showEventArchiveUsers: false,
        showExpertArchiveUsers: false,
        showEventShareUsers: false,
        showPrivateEventShareUsers: false,
        userList: [],
        groupList: [],
        alluserIds: null,
        videoShareSelectedUsers: [],
        companyShareSelectedUsers: [],
        personalShareSelectedUsers: [],
        trendingShareSelectedUsers: [],
        archiveEventsShareSelectedUsers: [],
        archiveExpertShareSelectedUsers: [],
        archivePlayerShareSelectedUsers: [],
        today: dateTime.toISOString(),
        startDate: dateTime.toISOString(),
        trialExpiryDate: dateTime.toISOString(),
        endDate: new Date(dateTime.setHours(dateTime.getHours() + 1)).toISOString(),
        largeNewImage: [],
        smallNewImage: [],
        status: [{name:'Select Status'}, {id:1, name:'Active'}, {id:0, name:'Inactive'}],
        corpStatus: [{name:'Select Page Status'}, {id:1, name:'Active'}, {id:0, name:'Inactive'}],
        spotlightSection: [{name:'Select Spotlight Status'}, {id:1, name:'Active'}, {id:0, name:'Inactive'}],
        pinnedSection: [{name:'Select Pinned Status'}, {id:1, name:'Active'}, {id:0, name:'Inactive'}],
        mobileFlags: [{id:1, name:'Show on Profile & Signup'}, {id:2, name:'Show on Profile'}, {id:3, name:'Show on Signup'}, {id:4, name:'Hide on Profile & Signup'}],
        dobFlags: [{id:1, name:'Show on Profile'}, {id:2, name:'Hide on Profile'}],
        shoeMotifFlags: [{id:1, name:'Show Shoe Motif'}, {id:2, name:'Hide Shoe Motif'}],
        corpVideoShareOptions: [{id:1, name:'Allow All Users Full Access'}, {id:4, name:'Allow Full Access to Selected Users'}, {id: 2, name:'All User share with Community with List of Users'}, {id: 3, name:'All User share with Individual with List of Users'}, {id: 5, name:'All User share with Friends with List of Users'},  {id: 0, name:'Do Not Allow Share'}],
        corpPersonalPlaylistOptions: [{id:1, name:'Allow All Users Full Access'}, {id: 0, name:'Do Not Allow Share'}],
        // corpPersonalPlaylistOptions: [{id:1, name:'Allow All Users Full Access'}, {id:4, name:'Allow Full Access to Selected Users'}, {id: 2, name:'Allow to selected Users'}, {id: 0, name:'Do Not Allow Share'}],
        corpEventShareOptions: [{id:1, name:'Allow All Users Full Access'}, {id:4, name:'Allow Full Access to Selected Users'}, {id: 0, name:'Do Not Allow Share'}],
        showCustomMessageFlag: false,
        giftIconStatus: [{id:1, name:'Gift of TONE Visible'}, {id:2, name:'Gift of TONE Invisible Without Custom Message'}, {id:3, name:'Gift of TONE Invisible With Custom Message'}],
        eventBannerStatus: [{id:1, name:'Link to Public Event'}, {id:2, name:'Link to Private Event'}, {id:3, name:'Custom Link'}],
        defaultCorpTabStatus: [{id:1, name:'Career Coaching'}, {id:2, name:'Community'}, {id:3, name:'Playlists'}, {id:4, name:'Videos'}],
        memebershipEmailsFlag: [{id:0, name:'No'}, {id:1, name:'Yes'}],
        showCustomBannerFlag: false,
        allowEmail: false,
        allowLiveSection: false,
        allowCustonSection: false,
        allowVideoShareSection: false,
        allowCoachingSection: false,
        allowPackageOverride: false,
        rules: {
          name : {required: true},
          description : {required: false},
          accountLimit : {required: true, numeric:true},
          domain : {required: false},
          invitation_code : {required: true, numeric:true},
          contactAddress : {required: false},
          contactCity : {required: false},
          contactEmail : {required: false, email:true},
          contactFirstName : {required: false},
          contactLastName : {required: false},
          contactPhone : {required: false, numeric:true},
          contactState : {required: false},
          contactZip : {required: false},
          largeImage : {required: false},
          smallImage : {required: false},
          active : {required: true},
          welcomeMessage : {required: true},
          button_label_01 : {required: true},
        }
      }
    },
    methods: {
      toggleSelection (permissionId, toggle) {
        if (toggle) { // Select All Option
          let userList = this.alluserIds
          if (permissionId === 'shareVideoPermission') {
            this.corporation.corpSharingPermissions.shrVidPermUserIdCsv = userList
          } else if (permissionId === 'shareCompanyPlaylistPermission') {
            this.corporation.corpSharingPermissions.shrCompPlistPermUserIdCsv = userList
          } else if (permissionId === 'sharePersonalPlaylistPermission') {
            this.corporation.corpSharingPermissions.shrPerPlistPermUserIdCsv = userList
          } else if (permissionId === 'shareTrendingPlaylistPermission') {
            this.corporation.corpSharingPermissions.shrTrndPlistPermUserIdCsv = userList
          } else if (permissionId === 'shareEventCoachingTipPermission') {
            this.corporation.corpSharingPermissions.shrEventCoachPlistPermUserIdCsv = userList
          } else if (permissionId === 'shareExpertCoachingTipPermission') {
            this.corporation.corpSharingPermissions.shrExpertCoachPlistPermUserIdCsv = userList
          } else if (permissionId === 'shareArchivePlistPermission') {
            this.corporation.corpSharingPermissions.shrArchivePlistPermUserIdCsv = userList
          } else if (permissionId === 'shareVideoRegularPermission') {
            this.corporation.corpSharingPermissions.shrVidRegularPermUserIdCsv = userList
          } else if (permissionId === 'corpPlaylistShareOptnPermission') {
            this.corporation.corpSharingPermissions.corpPlaylistShrareOptnCsv = userList
          } else if (permissionId === 'shareEventPermission') {
            this.corporation.corpSharingPermissions.corpEventShareOptnCsv = userList
          } else if (permissionId === 'sharePrivateEventPermission') {
            this.corporation.corpSharingPermissions.corpArchiveEventOptnCsv = userList
          } else {
          }
        } else {
          if (permissionId === 'shareVideoPermission') {
            this.corporation.corpSharingPermissions.shrVidPermUserIdCsv = null
          } else if (permissionId === 'shareCompanyPlaylistPermission') {
            this.corporation.corpSharingPermissions.shrCompPlistPermUserIdCsv = null
          } else if (permissionId === 'sharePersonalPlaylistPermission') {
            this.corporation.corpSharingPermissions.shrPerPlistPermUserIdCsv = null
          } else if (permissionId === 'shareTrendingPlaylistPermission') {
            this.corporation.corpSharingPermissions.shrTrndPlistPermUserIdCsv = null
          } else if (permissionId === 'shareEventCoachingTipPermission') {
            this.corporation.corpSharingPermissions.shrEventCoachPlistPermUserIdCsv = null
          } else if (permissionId === 'shareExpertCoachingTipPermission') {
            this.corporation.corpSharingPermissions.shrExpertCoachPlistPermUserIdCsv = null
          } else if (permissionId === 'shareArchivePlistPermission') {
            this.corporation.corpSharingPermissions.shrArchivePlistPermUserIdCsv = null
          } else if (permissionId === 'shareVideoRegularPermission') {
            this.corporation.corpSharingPermissions.shrVidRegularPermUserIdCsv = null
          } else if (permissionId === 'corpPlaylistShareOptnPermission') {
            this.corporation.corpSharingPermissions.corpPlaylistShrareOptnCsv = null
          } else if (permissionId === 'shareEventPermission') {
            this.corporation.corpSharingPermissions.corpEventShareOptnCsv = null
          } else if (permissionId === 'sharePrivateEventPermission') {
            this.corporation.corpSharingPermissions.corpArchiveEventOptnCsv = null
          } else {
          }
        }

      },
      update () {
        let startDate = new Date(this.startDate).getTime();
        let endDate = new Date(this.endDate).getTime();
        if (this.corporation.bnrLinkState > 1) {
          this.corporation.bnrPvtStartTime =  moment(startDate).format('MM/DD/YYYY H:mm:ss');
          this.corporation.bnrPvtEndTime =  moment(endDate).format('MM/DD/YYYY H:mm:ss');
        } else {
          this.corporation.bnrPvtStartTime =  null;
          this.corporation.bnrPvtEndTime =  null;
        }
        if (this.corporation.cceSendEmail !== 2) {
          this.corporation.cceSendEmail = this.allowEmail ? 1 : 0
        }
        // this.corporation.cceSendEmail = this.allowEmail ? 1 : 0
        this.corporation.useTrialEndDateCustom = this.allowPackageOverride ? 1: 0
        this.corporation.cceLiveEventParaAccess = this.allowLiveSection ? 1 : 0
        this.corporation.cceCommCoachingAccess = this.allowCoachingSection ? 1 : 0
        this.corporation.cceCustomContentAccess = this.allowCustonSection ? 1 : 0
        this.corporation.cceShareVideoAccess = this.allowVideoShareSection ? 1 : 0
        // if (this.allowPackageOverride) {
        //   this.corporation.trialEndDateCustom =  moment(this.trialExpiryDate).format('MM/DD/YYYY');
        // } else {
        //   this.corporation.trialEndDateCustom = null;
        // }

        // Normal Video Sharing Option Settings
        if (this.corporation.corpSharingPermissions.shareVideoPermission === '1' || this.corporation.corpSharingPermissions.shareVideoPermission === '0') {
          this.corporation.corpSharingPermissions.shrVidPermUserIdCsv = null
        } else {
          if (this.corporation.corpSharingPermissions.shrVidPermUserIdCsv) {
            this.corporation.corpSharingPermissions.shrVidPermUserIdCsv = this.corporation.corpSharingPermissions.shrVidPermUserIdCsv.join()
          }
        }
        // Normal Video Sharing Option Settings (Regular)
        if (this.corporation.corpSharingPermissions.corpPlaylistShareOptnPermission === '1' || this.corporation.corpSharingPermissions.corpPlaylistShareOptnPermission === '0') {
          this.corporation.corpSharingPermissions.corpPlaylistShrareOptnCsv = null
        } else {
          if (this.corporation.corpSharingPermissions.corpPlaylistShrareOptnCsv) {
            this.corporation.corpSharingPermissions.corpPlaylistShrareOptnCsv = this.corporation.corpSharingPermissions.corpPlaylistShrareOptnCsv.join()
          }
        }
        // Company Playlist Sharing Option Settings
        if (this.corporation.corpSharingPermissions.shareCompanyPlaylistPermission === '1' || this.corporation.corpSharingPermissions.shareCompanyPlaylistPermission === '0') {
          this.corporation.corpSharingPermissions.shrCompPlistPermUserIdCsv = null
        } else {
          if (this.corporation.corpSharingPermissions.shrCompPlistPermUserIdCsv) {
            this.corporation.corpSharingPermissions.shrCompPlistPermUserIdCsv = this.corporation.corpSharingPermissions.shrCompPlistPermUserIdCsv.join()
          }
        }
        // Personal Video Sharing Option Settings
        if (this.corporation.corpSharingPermissions.sharePersonalPlaylistPermission === '1' || this.corporation.corpSharingPermissions.sharePersonalPlaylistPermission === '0') {
          this.corporation.corpSharingPermissions.shrPerPlistPermUserIdCsv = null
        } else {
          if (this.corporation.corpSharingPermissions.shrPerPlistPermUserIdCsv) {
            this.corporation.corpSharingPermissions.shrPerPlistPermUserIdCsv = this.corporation.corpSharingPermissions.shrPerPlistPermUserIdCsv.join()
          }
        }
        // Trending Video Sharing Option Settings
        if (this.corporation.corpSharingPermissions.shareTrendingPlaylistPermission === '1' || this.corporation.corpSharingPermissions.shareTrendingPlaylistPermission === '0') {
          this.corporation.corpSharingPermissions.shrTrndPlistPermUserIdCsv = null
        } else {
          if (this.corporation.corpSharingPermissions.shrTrndPlistPermUserIdCsv) {
            this.corporation.corpSharingPermissions.shrTrndPlistPermUserIdCsv = this.corporation.corpSharingPermissions.shrTrndPlistPermUserIdCsv.join()
          }
        }
        // Archive(Events) Video Sharing Option Settings
        if (this.corporation.corpSharingPermissions.shareEventCoachingTipPermission === '1' || this.corporation.corpSharingPermissions.shareEventCoachingTipPermission === '0') {
          this.corporation.corpSharingPermissions.shrEventCoachPlistPermUserIdCsv = null
        } else {
          if (this.corporation.corpSharingPermissions.shrEventCoachPlistPermUserIdCsv) {
            this.corporation.corpSharingPermissions.shrEventCoachPlistPermUserIdCsv =  this.corporation.corpSharingPermissions.shrEventCoachPlistPermUserIdCsv.join()
          }
        }
        // Archive (experts) Video Sharing Option Settings
        if (this.corporation.corpSharingPermissions.shareExpertCoachingTipPermission === '1' || this.corporation.corpSharingPermissions.shareExpertCoachingTipPermission === '0') {
          this.corporation.corpSharingPermissions.shrExpertCoachPlistPermUserIdCsv = null
        } else {
          if (this.corporation.corpSharingPermissions.shrExpertCoachPlistPermUserIdCsv) {
            this.corporation.corpSharingPermissions.shrExpertCoachPlistPermUserIdCsv =  this.corporation.corpSharingPermissions.shrExpertCoachPlistPermUserIdCsv.join()
          }
        }
        // Archive Playlist Video Sharing Option Settings
        if (this.corporation.corpSharingPermissions.shareArchivePlistPermission === '1' || this.corporation.corpSharingPermissions.shareArchivePlistPermission === '0') {
          this.corporation.corpSharingPermissions.shrArchivePlistPermUserIdCsv = null
        } else {
          if (this.corporation.corpSharingPermissions.shrArchivePlistPermUserIdCsv) {
            this.corporation.corpSharingPermissions.shrArchivePlistPermUserIdCsv = this.corporation.corpSharingPermissions.shrArchivePlistPermUserIdCsv.join()
          }
        }
        // Event Sharing Option Settings
        if (this.corporation.corpSharingPermissions.corpEventShareOptnPermission === '1' || this.corporation.corpSharingPermissions.corpEventShareOptnPermission === '0') {
          this.corporation.corpSharingPermissions.corpEventShareOptnCsv = null
        } else {
          if (this.corporation.corpSharingPermissions.corpEventShareOptnCsv) {
            this.corporation.corpSharingPermissions.corpEventShareOptnCsv = this.corporation.corpSharingPermissions.corpEventShareOptnCsv.join()
          }
        }
        // Private Event Sharing Option Settings
        if (this.corporation.corpSharingPermissions.corpArchiveEventOptnPermission === '1' || this.corporation.corpSharingPermissions.corpArchiveEventOptnPermission === '0') {
          this.corporation.corpSharingPermissions.corpArchiveEventOptnCsv = null
        } else {
          if (this.corporation.corpSharingPermissions.corpArchiveEventOptnCsv) {
            this.corporation.corpSharingPermissions.corpArchiveEventOptnCsv = this.corporation.corpSharingPermissions.corpArchiveEventOptnCsv.join()
          }
        }
        if (this.corporation.csvCorpSuperUserIds) {
          this.corporation.csvCorpSuperUserIds = this.corporation.csvCorpSuperUserIds.join()
        }
        this.corporation.trialEndDateCustom = null
        this.corporation.useTrialEndDateCustom = 0
        console.log('current corp 1', this.corporation)
        this.$validator.validateAll().then((result) => {
          if(result){
            let update = () =>{
              this.$store.dispatch('UPDATE_CORPORATION', {
                corporation: this.corporation,
                largeImage: this.largeNewImage,
                smallImage: this.smallNewImage
              })
                .then((res) => {
                  console.log("UPDATE_CORPORATION res : ", res);
                  this.showPopup('Success!', 'Corporation is successfully updated', 'success', ()=>this.$router.push('/admin/corporations'))
                })
                .catch(err => {
                  this.showPopup('Error!', 'some thing happen wrong', 'error')
                  console.log("UPDATE_CORPORATION API error : ", err);
                })
            };
            update();
          }
        })
        console.log("this.corporations : ", this.corporations);
      },
      showPopup(title, msg, popupType, cb){
        this.$swal( title, msg, popupType
        ).then(res => {
          cb && cb();
          return res
        })
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      updateLargeImg(data){
        this.corporation.largeImage = data.path;
        this.largeNewImage = data.value;
        console.log("updateLargeImg data : ", data);
      },
      updateSmallImg(data){
        this.corporation.smallImage = data.path;
        this.smallNewImage = data.value;
        console.log("updateSmallImg data : ", data);
      },
      fetchAllUsers (corporationId) {
        this.$store.dispatch('GET_CORP_USERS', corporationId)
          .then((res) => {
            if (res && res.length > 0) {
              console.log('inside if')
              this.userList = res;
              this.alluserIds = this.userList.map(x => {
                return x.id.toString()
              })
            } else {
              this.userList = []
            }
          })
          .catch(err => {
            console.log("API error : ", err);
          })
          , (err) => {
          this.filteredData = []
          console.log("err : ", err);
        }
      },
      fetchAllGroups () {
        this.$store.dispatch('GET_CORP_GROUPS')
          .then((res) => {
            // let allGroups = res;
            this.groupList = res.map(x => {
              return {
                id : x.groupDefinitionId,
                name: x.groupTitle
              }
            })
            this.groupList.unshift({id: 0, name: "Default Group (Default Theme)"});
            console.log('list of all groups', this.groupList)
          })
          .catch(err => {
            console.log("API error : ", err);
          })
          , (err) => {
          console.log("err : ", err);
        }
      }

    },
    watch: {
      'corporation.giftIconState' (to, from) {
        let self = this
        console.info('watch called', to)
        if (self.corporation.giftIconState === '3') {
          self.showCustomMessageFlag = true
          self.corporation.giftIconMessage = '',
            self.corporation.giftIconUrl = ''
        } else {
          self.showCustomMessageFlag = false
          self.corporation.giftIconMessage = '',
            self.corporation.giftIconUrl = ''
        }
      },
      'corporation.bnrLinkState' (to, from) {
        let self = this
        if (self.corporation.bnrLinkState >  1) {
          self.showCustomBannerFlag = true
          self.corporation.bnrCustomMsg = '',
            self.corporation.bnrCustomMsgUrl = ''
        } else {
          self.showCustomBannerFlag = false
          self.corporation.bnrCustomMsg = '',
            self.corporation.bnrCustomMsgUrl = ''
        }
      }
    },
    computed: {
      ...mapGetters([ 'corporations', 'selectedCorporation']),
      routeName () {
        const {name} = this.$route;
        return this.capitalizeFirstLetter(name);
      },
      corporation(){
        return this.selectedCorporation
      }
    }
  }
</script>
<style scoped>
  legend {
    color: deepskyblue;
    text-align: center;
    padding: 25px;
    /* text-underline-position: under; */
  }
  .btn {
    background-color: DodgerBlue; /* Blue background */
    border: none; /* Remove borders */
    color: white; /* White text */
    padding: 12px 16px; /* Some padding */
    font-size: 16px; /* Set a font size */
    cursor: pointer; /* Mouse pointer on hover */
  }

  /* Darker background on mouse-over */
  .btn:hover {
    background-color: RoyalBlue;
  }
</style>

<style>
  .form-control{
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Corporations/EditCorporation.vue